// Core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { PipesModule } from '../pipes/pipes.module';
import { DirectivesModule } from '../directives/directives.module';

// Libraries
import { MDBBootstrapModule } from 'angular-bootstrap-md'
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DataTablesModule } from "angular-datatables";
import { YouTubePlayerModule } from '@angular/youtube-player';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgxFilesizeModule } from 'ngx-filesize';
import { FilePickerModule } from '@anaidenko/ngx-awesome-uploader';
import { DragDropModule } from '@angular/cdk/drag-drop';

// Components
import { CloseButtonComponent } from './components/close-button/close-button.component';
import { YoutubePlayerComponent } from './components/youtube-player/youtube-player.component';
import { VideoJsPlayerComponent } from './components/video-js-player/video-js-player.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';

// Dialogs
import { ChallengePropertyDialogComponent } from './dialogs/challenge-property-dialog/challenge-property-dialog.component';
import { ClientPropertyFilesUploadDialogComponent } from './dialogs/client-property-files-upload-dialog/client-property-files-upload-dialog.component';
import { UploadPropertiesDialogComponent } from './dialogs/upload-properties-dialog/upload-properties-dialog.component';

const Core = [
  BrowserModule,
  BrowserAnimationsModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  PipesModule,
  DirectivesModule
];

const Libraries = [
  MDBBootstrapModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatDatepickerModule,
  MatDialogModule,
  MatInputModule,
  MatFormFieldModule,
  MatNativeDateModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatTooltipModule,
  PdfViewerModule,
  DataTablesModule,
  MatTableModule,
  MatCheckboxModule,
  YouTubePlayerModule,
  RecaptchaModule,
  RecaptchaFormsModule,
  EditorModule,
  NgxFilesizeModule,
  FilePickerModule,
  DragDropModule,
];

const Components = [
  CloseButtonComponent,
  YoutubePlayerComponent,
  VideoJsPlayerComponent,
  FileUploaderComponent,
];

const Dialogs = [
  ChallengePropertyDialogComponent,
  ClientPropertyFilesUploadDialogComponent,
  UploadPropertiesDialogComponent,
];

@NgModule({
  declarations: [
    ...Components,
    ...Dialogs,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    ...Core,
    ...Libraries,
  ],
  exports: [
    ...Core,
    ...Libraries,
    ...Components,
  ]
})
export class SharedModule { }
